import React from 'react';
import { ForgotPassword } from '../components/pages';

export default function ForgotPasswordPage() {
  return (
    <div className="wrapper wrapper-full-page">
      <div
        className="full-page login-page"
        data-color="color"
        data-image="../../assets/img/background/background-2.jpg"
      >
        <div className="content">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-lg-8">
                <ForgotPassword />
              </div>
            </div>
          </div>
        </div>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url("../../assets/img/background/background-2.jpg")`,
          }}
        />
      </div>
    </div>
  );
}
